export const isPastDate = (date?: Date): boolean =>
  date !== undefined && Date.now() > date.getTime();
